/**
 * @file
 */

window.fwbPoints = {
  matches: function(name = 'none', max = false) {
    const breakpoints = {
      none:'0px',
      '800px': '800px',
      small_screen: '30em',
      medium_screen: '40em',
      large_screen: '60em',
    };

    let breakpoint = breakpoints[name];

    const mediaQueryString = '(' + (max ? 'max' : 'min' ) + '-width: ' + breakpoint + ')';

    const mediaQuery = window.matchMedia(mediaQueryString);

    return mediaQuery.matches;
  }
}


